import { useEffect, useRef, useState } from 'react';

const formatTime = (ts) => {
  if (!ts) return '';
  const d = ts.toDate ? ts.toDate() : (ts instanceof Date ? ts : new Date(ts));
  return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
};

/**
 * Dialogue centralisé d'une demande : affichage des messages + réponse de l'équipe.
 * Scroll automatique vers le dernier message.
 */
const RequestMessages = ({ messages, onSend, isSending }) => {
  const [content, setContent] = useState('');
  const scrollRef = useRef(null);

  // Scroll auto vers le dernier message
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({ top: scrollRef.current.scrollHeight, behavior: 'smooth' });
    }
  }, [messages]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!content.trim() || isSending) return;
    onSend({ content: content.trim(), staffName: 'Équipe MonSiteDirect' });
    setContent('');
  };

  return (
    <div>
      <div ref={scrollRef} className="space-y-3 max-h-[280px] overflow-y-auto pr-1 mb-3">
        {messages.length === 0 && (
          <p className="text-sm text-base-content/50 italic text-center py-4">Aucun message pour le moment.</p>
        )}
        {messages.map((msg, index) => (
          <div key={index} className={`flex ${msg.isStaff ? 'justify-start' : 'justify-end'}`}>
            <div className={`max-w-[80%] rounded-lg p-3 ${msg.isStaff ? 'bg-base-200 border border-base-200' : 'bg-primary text-primary-content'}`}>
              <div className="text-xs font-medium opacity-80">{msg.isStaff ? 'Notre équipe' : msg.authorName || 'Client'}</div>
              <div className="text-sm whitespace-pre-wrap break-words mt-1">{msg.content}</div>
              <div className="text-[10px] opacity-60 mt-1 text-right">{formatTime(msg.timestamp)}</div>
            </div>
          </div>
        ))}
      </div>
      <form onSubmit={handleSubmit} className="flex gap-2">
        <textarea
          className="textarea textarea-bordered flex-1"
          rows={2}
          placeholder="Réponse au client..."
          value={content}
          onChange={(e) => setContent(e.target.value)}
          disabled={isSending}
        />
        <button type="submit" className="btn btn-primary" disabled={isSending || !content.trim()}>
          {isSending ? 'Envoi...' : 'Envoyer'}
        </button>
      </form>
    </div>
  );
};

export default RequestMessages;
